// require('./vendor'); // vem do webkit

import LocomotiveScroll from 'locomotive-scroll';
const locomotiveScroll = new LocomotiveScroll({
    lenisOptions: {
        wrapper: window,
        content: document.documentElement,
        lerp: 0.1,
        duration: 1.5,
        orientation: 'vertical',
        gestureOrientation: 'vertical',
        smooth: true,
        smoothMobile: true,
        smoothWheel: true,
        smoothTouch: false,
        wheelMultiplier: 1,
        touchMultiplier: 1,
        normalizeWheel: true,
        smoothTouch: true,
        smartphone: {
            smooth: true,
        },
        mobile: {
            breakpoint: 768,
            smooth: true,
            getDirection: true,
        },
        tablet: {
            breakpoint: 1000,
            smooth: true,
            getDirection: true,
        }
        //easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // https://www.desmos.com/calculator/brs54l4xou
    },
});


// require('../../node_modules/jquery-validation/dist/jquery.validate');

window.$ = window.jQuery = require('jquery');

//-> Lib GSAP
import { gsap } from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin.js";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(PixiPlugin, MotionPathPlugin, ScrollTrigger, ScrollToPlugin);

import * as svg from "./components/svg";
import * as mask from "./components/inputMask";
import windowScrollPage from "./components/windowScrollPage";
import * as bootstrap from 'bootstrap'
import LoadPage from "./components/AjaxLoadPage";
import Swiper from "./components/SwiperGallery";
import videoToggle from "./components/Video";
// import 'slick-carousel';
// import * as gallery             from "./components/slick-carrossel";
import * as jqValidate          from "./components/JqValidate";
import * as FormAjax 			from "./components/FormAjax";
import ModalWhats from './components/ModalWhats';


window.addEventListener('load', function() {
    render();
});

const render = () => {

    LoadPage.init();
    windowScrollPage.init();
    svg.init();
    mask.jqMAsk();
    Swiper.init();
    videoToggle.init();
    ModalWhats.init();
    jqValidate.formAjax();
    FormAjax.init();

    if($(window).width() > 768){
        const blockGray = $("#block-dark-gray-h");
        const blockWrapList = $("#wrap-list-h");
        const blockGrayHeight = blockGray.height();
    
        blockWrapList.height(blockGrayHeight);
    }

}